import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import AboutSection from '../components/AboutSection';
import StatsCounter from '../components/StatsCounter';
import TestimonialsSection from '../components/TestimonialsSection';
import { team } from '../data/mock';
import { Linkedin, Twitter } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function AboutPage() {
  const { t } = useLang();
  return (
    <>
      <Header />
      <PageHeader title={t('page.about')} breadcrumb={[t('page.crumb.about')]} />
      <AboutSection />
      <StatsCounter />

      <section className="py-24 bg-[#faf6ec]">
        <div className="max-w-[1280px] mx-auto px-6">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <p className="section-eyebrow mb-4">{t('team.eyebrow')}</p>
            <h2 className="text-[36px] md:text-[44px] leading-[1.1] font-extrabold text-[#14110f]">
              {t('team.titlePre')} <span className="text-[#f5b300]">{t('team.titleAccent')}</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {team.map((m) => (
              <div key={m.id} className="group rounded-xl overflow-hidden bg-white shadow-[0_18px_45px_-25px_rgba(20,17,15,0.18)] hover:-translate-y-1.5 transition-all">
                <div className="relative h-72 overflow-hidden">
                  <img src={m.image} alt={m.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-x-0 bottom-0 p-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                    <a href="#" className="w-9 h-9 rounded-full bg-[#f5b300] flex items-center justify-center"><Linkedin className="w-4 h-4 text-[#14110f]" /></a>
                    <a href="#" className="w-9 h-9 rounded-full bg-white flex items-center justify-center"><Twitter className="w-4 h-4 text-[#14110f]" /></a>
                  </div>
                </div>
                <div className="p-5 text-center">
                  <p className="font-bold text-[16px] text-[#14110f] group-hover:text-[#c89200] transition-colors">{m.name}</p>
                  <p className="text-[12.5px] text-neutral-500 mt-1">{m.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <TestimonialsSection />
      <Footer />
    </>
  );
}
